module.exports = __webpack_public_path__ + "static/media/track_and_improve.bf133642.svg";